import { z } from 'zod';
export const FRENCH_IDENTIFIER_INPUT_MAX_LENGTH = 32;
const SIREN_PATTERN = /^\d{9}$/u;
const SIRET_PATTERN = /^\d{14}$/u;
function identifierInput(pattern, message) {
    return z
        .string()
        .max(FRENCH_IDENTIFIER_INPUT_MAX_LENGTH, message)
        .transform((value) => value.replace(/\s/gu, ''))
        .refine((value) => value === '' || pattern.test(value), message)
        .transform((value) => (value === '' ? null : value))
        .nullish();
}
export const sirenInputSchema = identifierInput(SIREN_PATTERN, 'frenchIdentifiers.sirenInvalid');
export const siretInputSchema = identifierInput(SIRET_PATTERN, 'frenchIdentifiers.siretInvalid');
export function refineFrenchCompanyIdentifiers(value, context) {
    const siren = value.siren?.replace(/\s/gu, '');
    const siret = value.siret?.replace(/\s/gu, '');
    if (typeof siren === 'string' &&
        typeof siret === 'string' &&
        SIREN_PATTERN.test(siren) &&
        SIRET_PATTERN.test(siret) &&
        !siret.startsWith(siren)) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['siret'],
            message: 'frenchIdentifiers.mismatch',
        });
    }
}
export const frenchCompanyIdentifiersSchema = z
    .object({ siren: sirenInputSchema, siret: siretInputSchema })
    .superRefine(refineFrenchCompanyIdentifiers);
// Existing untouched values remain readable while edited fields are validated separately.
export const frenchCompanyIdentifierConsistencySchema = z
    .object({ siren: z.string().nullish(), siret: z.string().nullish() })
    .superRefine(refineFrenchCompanyIdentifiers);
//# sourceMappingURL=french-company-identifiers.js.map